/**
 * שלד העמוד הציבורי — TASKS 4.1.
 *
 * ⭐ קישור "דלג לתוכן הראשי" חייב להיות הראשון ב-tab (PRD 12.4) — ולכן הוא
 *    האלמנט הראשון שמעניקים לו focus order, לפני ה-Header.
 *
 * ⭐ TASKS 4.6 — `AccessibilityWidget` (הכפתור הצף) מוצג כאן, ⛔ בצד הציבורי
 *    בלבד — בדיוק כמו Header/Footer/skip-link. פאנל הניהול (`/admin/*`)
 *    לא עובר דרך `Layout` וטרם קיבל את סבב העיצוב המרוכז (TASKS 3.6/4.1).
 *
 * ⭐ 16.08.2026 — `WhatsAppFab` נוסף כפתור צף שני, בפינה הנגדית ל-a11y.
 *    ראו האזהרה המלאה ב-`WhatsAppFab.tsx` (הופך החלטת DESIGN.md 5.10).
 *
 * ⭐ 27.08.2026 — `CookieConsentBanner` (רצועה תחתונה + פאנל העדפות), צד
 *    ציבורי בלבד כמו כל השאר כאן. ראו `consent/CookieConsentContext.tsx`.
 */
import type { ReactNode } from 'react';
import { AccessibilityWidget } from '../accessibility/AccessibilityWidget.js';
import { CookieConsentBanner } from '../consent/CookieConsentBanner.js';
import { Footer } from './Footer.js';
import { Header } from './Header.js';
import { WhatsAppFab } from './WhatsAppFab.js';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <>
      <a className="skip-link" href="#main">
        דלג לתוכן הראשי
      </a>

      <Header />

      <main id="main">{children}</main>

      <Footer />

      <CookieConsentBanner />
      <AccessibilityWidget />
      <WhatsAppFab />
    </>
  );
}
